const roundBase = {
    score: [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    tot: 0,
    ptsScore: 0,
    ptsPos: 0,
    pos: 0,
    ties: 0
}

export default roundBase